// 仕様: docs/QR_SPECIFICATION.md §2 と同期

export const VALID_MODELS: ReadonlySet<number> = new Set([1, 3, 4, 11, 12, 13]);

/** 耳バリアントを許容するモデル番号（11/12/13 humanoid は不可） */
export const EAR_VARIANT_MODELS: ReadonlySet<number> = new Set([1, 3, 4]);

/** 有効な耳サフィックス */
export const EAR_VARIANTS: ReadonlySet<string> = new Set(['', 'a', 'b', 'c']);

export const BODY_ALLOW: ReadonlySet<string> = new Set([
  // 基本色 (8)
  'red', 'blue', 'green', 'yellow', 'pink', 'white', 'black', 'orange', 'purple',
  // Point 柄 = 進化 tier 2/3 で使われる polkaDot 系
  'redPoint', 'bluePoint', 'greenPoint', 'yellowPoint', 'pinkPoint',
  'blackPoint', 'orangePoint', 'purplePoint', 'blackGrade',
  // Stripe 縦縞 (Tier 2)
  'redStripeV', 'blueStripeV', 'greenStripeV', 'yellowStripeV',
  'orangeStripeV', 'purpleStripeV',
  // Stripe 横縞 (Tier 2)
  'redStripeH', 'blueStripeH', 'greenStripeH', 'yellowStripeH',
  'orangeStripeH', 'purpleStripeH',
]);

// SCALE_TABLE は本体 GameEngine.ts と同一
export const SCALE_TABLE = [0, 0.75, 0.875, 1.0, 1.125, 1.25] as const;

export const FACE_TEXTURE_COUNT = 9;

export const ASSET_BASE = '/assets';

export function modelUrl(m: number, e: string = ''): string {
  // 耳付きモデル (1a/3b/4c 等) と耳なしモデル両方をカバー
  const suffix = EAR_VARIANT_MODELS.has(m) && (e === 'a' || e === 'b' || e === 'c') ? e : '';
  return `${ASSET_BASE}/models/character_${String(m).padStart(2, '0')}${suffix}.glb`;
}

export function bodyTextureUrl(b: string): string {
  return `${ASSET_BASE}/textures/${b}.png`;
}

export function faceTextureUrl(f: number): string {
  return `${ASSET_BASE}/textures/face_texture_${f}.png`;
}
